/* import __COLOCATED_TEMPLATE__ from './outbound-fields.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import {
  type ReplyChannel,
  replyChannelIsEmail,
  replyChannelIsWhatsapp,
  replyChannelIsSlack,
} from 'embercom/objects/inbox/composer-pane';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type UserSummary from 'embercom/objects/inbox/user-summary';
// @ts-ignore
import { ref } from 'ember-ref-bucket';
import { type MessageSender } from 'embercom/objects/inbox/conversation';
import { tracked } from '@glimmer/tracking';
import { type Recipients } from 'embercom/lib/composer/recipients';

export type OutboundFieldVisibilitySettings = {
  hideSenderField?: boolean;
  hideRecipientsField?: boolean;
  hideSubjectField?: boolean;
};

interface Args {
  channel: ReplyChannel;
  sender: MessageSender | undefined;
  onSenderChange?: (sender: any) => void;
  setRecipientErrors?: (
    recipientsWithErrors: { recipient: UserSummary; recipientError: string | void }[],
  ) => void;
  recipients?: Recipients;
  replyChannel: ReplyChannel;
  onRecipientChange: (recipients: Recipients) => void;
  title?: string;
  setTitle?: Function;
  isCreatingConversation?: boolean;
  keyboardPriority?: number;
  isSideConversationComposer?: boolean;
  outboundFieldVisibilitySettings?: OutboundFieldVisibilitySettings;
  selectedSlackChannelId?: string | null;
  onSlackChannelChange?: (channelId: string | null) => void;
  recipientUserId?: string;
  onSenderBrandMismatch?: (hasMismatch: boolean) => void;
}

interface Signature {
  Args: Args;
}

export default class OutboundFields extends Component<Signature> {
  @service declare session: Session;
  readonly replyChannelIsEmail = replyChannelIsEmail;
  readonly replyChannelIsWhatsapp = replyChannelIsWhatsapp;
  readonly replyChannelIsSlack = replyChannelIsSlack;
  @tracked customAddressExists = false;

  @ref('subject-input') declare subjectInput: HTMLElement;

  @action selectSubjectField() {
    this.subjectInput?.focus();
  }

  get shouldAddRecipientDataAttribute(): boolean {
    return this.replyChannelIsEmail(this.args.replyChannel);
  }

  get channelIsWhatsapp(): boolean {
    return this.replyChannelIsWhatsapp(this.args.replyChannel);
  }

  get showSenderField(): boolean {
    return this.args.outboundFieldVisibilitySettings?.hideSenderField !== true;
  }

  get showRecipientsField(): boolean {
    return this.args.outboundFieldVisibilitySettings?.hideRecipientsField !== true;
  }

  get showSubjectField(): boolean {
    return this.args.outboundFieldVisibilitySettings?.hideSubjectField !== true;
  }

  get showChannelField(): boolean {
    return (
      this.replyChannelIsSlack(this.args.replyChannel) && !!this.args.isSideConversationComposer
    );
  }

  @action
  setCustomAddressExists(customAddressExists: boolean) {
    this.customAddressExists = customAddressExists && !!this.args.isSideConversationComposer;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::OutboundFields': typeof OutboundFields;
    'inbox2/composer/outbound-fields': typeof OutboundFields;
  }
}
